/**
 * Swedish forms for the most common skill synonym groups (TEC-711). The data lake has no Swedish
 * skills column, so these are curated by hand. Each entry is [anchor, ...swedish]: the anchor is a
 * normalised English or Finnish name from skill-synonyms.generated.ts, and the Swedish names join
 * that group. An anchor not found in the mined groups starts a new group.
 */
export const SV_SKILL_SYNONYMS: readonly (readonly string[])[] = [
  ['customer service', 'kundservice', 'kundtjänst'],
  ['customer service skills', 'kundservicefärdigheter'],
  ['teamwork', 'teamarbete', 'lagarbete', 'samarbete i team'],
  ['communication skills', 'kommunikationsförmåga', 'kommunikationsfärdigheter'],
  ['communication', 'kommunikation'],
  ['interaction skills', 'samarbetsförmåga'],
  ['project management', 'projektledning'],
  ['data analysis', 'dataanalys'],
  ['leadership', 'ledarskap'],
  ['team leadership', 'teamledning', 'teamledarskap'],
  ['flexibility', 'flexibilitet'],
  ['empathy', 'empati'],
  ['customer relationship management', 'kundrelationshantering'],
  ['negotiation', 'förhandling', 'förhandlingsförmåga'],
  ['sales', 'försäljning'],
  ['sales skills', 'säljförmåga', 'försäljningsfärdigheter'],
  ['b2b sales', 'b2b-försäljning'],
  ['sales management', 'försäljningsledning'],
  ['troubleshooting', 'felsökning'],
  ['safety procedures', 'säkerhetsrutiner'],
  ['stakeholder management', 'intressenthantering'],
  ['physical fitness', 'fysisk kondition', 'god fysik'],
  ['problem solving', 'problemlösning'],
  ['strategic planning', 'strategisk planering'],
  ['it skills', 'it-kunskaper', 'datorvana'],
  ['patient care', 'patientvård'],
  ['finnish language', 'finska', 'finska språket', 'kunskaper i finska'],
  ['english', 'engelska'],
  ['english language', 'engelska språket'],
  ['english proficiency', 'kunskaper i engelska'],
  ['organizational skills', 'organisationsförmåga'],
  ['pedagogical skills', 'pedagogisk förmåga', 'pedagogiska färdigheter'],
  ['driving license', 'körkort'],
  ['driving license b', 'b-körkort', 'körkort b'],
  ['erp systems', 'affärssystem', 'erp-system'],
  ['attention to detail', 'noggrannhet'],
  ['electrical systems', 'elsystem'],
  ['electrical installation', 'elinstallation'],
  ['electrical installations', 'elinstallationer'],
  ['electrical safety', 'elsäkerhet'],
  ['electrical engineering', 'elteknik'],
  ['electrical design', 'elkonstruktion'],
  ['medication administration', 'läkemedelshantering', 'läkemedelsbehandling'],
  ['automation', 'automation', 'automatisering'],
  ['automation systems', 'automationssystem'],
  ['technical drawing reading', 'ritningsläsning', 'läsa ritningar'],
  ['safety awareness', 'säkerhetsmedvetenhet'],
  ['inventory management', 'lagerhantering', 'lagerstyrning'],
  ['networking', 'nätverkande'],
  ['food preparation', 'matlagning', 'tillagning av mat'],
  ['cooking', 'matlagning'],
  ['market analysis', 'marknadsanalys'],
  ['market research', 'marknadsundersökning'],
  ['risk management', 'riskhantering'],
  ['risk assessment', 'riskbedömning'],
  ['cleaning', 'städning', 'rengöring'],
  ['cleaning skills', 'städkunskaper'],
  ['cloud services', 'molntjänster'],
  ['welding', 'svetsning'],
  ['tig welding', 'tig-svetsning'],
  ['mig welding', 'mig-svetsning'],
  ['mag welding', 'mag-svetsning'],
  ['mig/mag welding', 'mig/mag-svetsning'],
  ['ai tools', 'ai-verktyg'],
  ['tekoäly', 'artificiell intelligens'],
  ['quality control', 'kvalitetskontroll'],
  ['quality assurance', 'kvalitetssäkring'],
  ['time management', 'tidshantering', 'tidsplanering'],
  ['cnc machining', 'cnc-bearbetning'],
  ['cnc programming', 'cnc-programmering'],
  ['reliability', 'pålitlighet'],
  ['documentation', 'dokumentation'],
  ['technical documentation', 'teknisk dokumentation'],
  ['content creation', 'innehållsproduktion', 'innehållsskapande'],
  ['independence', 'självständighet', 'självständigt arbete'],
  ['business development', 'affärsutveckling'],
  ['collaboration', 'samarbete'],
  ['collaboration skills', 'samarbetsförmåga'],
  ['hydraulics', 'hydraulik'],
  ['crm systems', 'crm-system'],
  ['digital tools', 'digitala verktyg'],
  ['financial analysis', 'finansiell analys'],
  ['financial reporting', 'finansiell rapportering'],
  ['financial management', 'ekonomiförvaltning', 'ekonomistyrning'],
  ['budgeting', 'budgetering'],
  ['teaching skills', 'undervisningsförmåga'],
  ['excavator operation', 'grävmaskinsförare', 'körning av grävmaskin'],
  ['hvac systems', 'vvs-system'],
  ['työturvallisuuskortti', 'arbetarskyddskort'],
  ['hygieniapassi', 'hygienpass'],
  ['tulityökortti', 'heta arbeten-kort', 'certifikat för heta arbeten'],
  ['machine learning', 'maskininlärning'],
  ['process improvement', 'processförbättring', 'processutveckling'],
  ['shift work', 'skiftarbete'],
  ['reporting', 'rapportering'],
  ['cash handling', 'kassahantering', 'kassaarbete'],
  ['agile methodologies', 'agila metoder'],
  ['logistics', 'logistik'],
  ['data management', 'datahantering'],
  ['maintenance', 'underhåll'],
  ['product knowledge', 'produktkännedom'],
  ['contract management', 'avtalshantering'],
  ['forklift operation', 'truckkörning', 'truckkort'],
  ['change management', 'förändringsledning'],
  ['customer support', 'kundsupport'],
  ['occupational safety', 'arbetarskydd', 'arbetssäkerhet'],
  ['procurement', 'inköp', 'upphandling'],
  ['supply chain management', 'hantering av leveranskedjan'],
  ['programming', 'programmering'],
  ['software development', 'mjukvaruutveckling', 'programvaruutveckling'],
  ['presentation skills', 'presentationsförmåga'],
  ['food safety', 'livsmedelshygien', 'livsmedelssäkerhet'],
  ['analytical skills', 'analytisk förmåga'],
  ['event planning', 'evenemangsplanering'],
  ['pipe installation', 'rörinstallation', 'rörarbeten'],
  ['social media management', 'hantering av sociala medier'],
  ['technical skills', 'tekniska färdigheter'],
  ['child development', 'barns utveckling'],
  ['metalworking', 'metallarbete'],
  ['painting', 'målning'],
  ['product management', 'produktledning'],
  ['initiative', 'initiativförmåga', 'eget initiativ'],
  ['multidisciplinary teamwork', 'multiprofessionellt samarbete'],
  ['vehicle maintenance', 'fordonsunderhåll'],
  ['accounting', 'bokföring', 'redovisning'],
  ['marketing', 'marknadsföring'],
  ['digital marketing', 'digital marknadsföring'],
  ['recruitment', 'rekrytering'],
  ['nursing', 'sjukvård', 'omvårdnad'],
  ['early childhood education', 'småbarnspedagogik'],
];
